export default __webpack_public_path__ + "static/media/toast-success.c3979453.svg";